import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";

import logo from "../../../assets/images/logo colegio (32).png";
import "./SiteShell.css";

export default function SiteFooter() {
  return (
    <footer className="tc-site-footer">
      <div className="tc-site-footer-main">
        <div className="tc-site-footer-brand">
          <img src={logo} alt="Colegio Santo Tomás" />
          <div>
            <span>Fundación educativa</span>
            <h2>Colegio Santo Tomás</h2>
            <p>Una comunidad educativa que acompaña cada etapa con conocimiento, valores y compromiso.</p>
          </div>
        </div>

        <div className="tc-site-footer-links">
          <section>
            <h3>Contacto</h3>
            <a href="tel:+542954313911"><FaPhone /> +54 2954 313911</a>
            <a href="mailto:administracion@fundacioncolegiosantotomas.com.ar"><FaEnvelope /> Administración</a>
            <p><FaMapMarkerAlt /> Santiago del Estero 666, Santa Rosa</p>
          </section>
          <section>
            <h3>Accesos</h3>
            <Link to="/nueva-admision">Admisiones</Link>
            <Link to="/proyectoEducativo">Proyecto educativo</Link>
            <Link to="/contacto">Contacto</Link>
          </section>
          <section>
            <h3>Portal</h3>
            <Link to="/login">Acceso familias</Link>
            <Link to="/loginEmpleados">Acceso empleados</Link>
            <Link to="/trabajaConNosotros">Trabajá con nosotros</Link>
          </section>
        </div>
      </div>

      <div className="tc-site-footer-bottom">
        <span>© {new Date().getFullYear()} Colegio Santo Tomás</span>
        <div>
          <a href="https://www.instagram.com/santotomassr/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://www.facebook.com/santotomasinstitucional" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
          <a href="https://wa.me/5492954313911" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
        </div>
      </div>
    </footer>
  );
}
